var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPurpleBlob(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 414,
    height: 138,
    viewBox: "0 0 414 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0498 58.0841C-32.9377 52.1248 18.1892 127.298 92.4545 113.485C131.612 106.203 170.565 104.108 209.555 110.027C219.039 111.467 222.693 116.428 230.423 120.389C255.047 133.008 284.969 141.884 312.001 131.517C336.496 122.123 342.63 79.9699 367.578 77.481C445.924 69.6646 418.573 34.6336 334.268 32.8549C293.073 31.9854 223.751 -14.6782 187.559 4.71214C152.028 23.7496 41.2087 59.7446 25.0498 58.0841Z",
    fill: "#3D0791"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.86 58.1585C-1.28338 58.1585 -2.04027 75.1616 5.73732 85.7974C15.3357 98.9238 34.6897 112.21 50.3602 116.228C107.231 130.81 113.826 112.19 164.772 105.658C186.346 102.892 215.25 113.265 232.09 121.9C238.555 125.216 270.733 135.823 277.836 136.733C313.253 141.272 314.866 133.347 339.059 103.82C342.41 99.7306 352.702 84.9314 352.391 85.2125C318.507 115.8 193.144 100.175 186.663 73.6026C178.978 42.098 114.439 60.7542 91.0349 82.0612C63.5946 107.042 5.44515 70.922 10.86 58.1585Z",
    fill: "#37156B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.098 38.6093C162.656 29.955 194.515 -1.88329 223.202 9.24723C232.372 12.8052 295.598 36.0172 304.653 37.0823C335.11 40.6657 344.849 45.8076 304.183 56.6627C278.883 63.4162 220.575 54.7307 214.966 39.6368C210.572 27.8102 187.561 45.9897 176.098 38.6093Z",
    fill: "#501BA2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M208.381 18.4746C207.421 10.6754 235.728 15.291 245.411 24.8948C251.601 31.0348 263.353 27.251 270.449 32.7611C274.912 36.2266 287.592 40.2241 286.67 40.9587C277.579 48.2028 274.259 43.1783 270.753 43.2527C253.053 43.6279 214.302 25.365 218.415 22.0816C219.502 21.2147 208.481 19.2845 208.381 18.4746Z",
    fill: "#6B3AB5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleBlob);
export default __webpack_public_path__ + "static/media/purple-blob.431f223a324c3cc9be72ab418ab78a91.svg";
export { ForwardRef as ReactComponent };